import { Injectable } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { DialogService } from '@tv3/services/utils/dialog.service'
import { PushRatesOverlayComponent } from '@tv3/containers/rates/push-rates/push-rates-overlay.component'

@Injectable()
export class PushRatesOverlayService {
  constructor(private dialogService: DialogService) {}

  public openSide(data): MatDialogRef<PushRatesOverlayComponent, void> {
    return this.dialogService.openLargeSide(PushRatesOverlayComponent, {
      panelClass: ['modal', 'side-modal-lg', 'right'],
      data,
    })
  }
}
